export default { sha: 'e1f6b4ac1f872c88adab904566329ed47e2f05aa', buildNumber: 'undefined' }
